var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWordOfMouthIsKing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#00B84B",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 37V35C33 33.9391 32.5786 32.9217 31.8284 32.1716C31.0783 31.4214 30.0609 31 29 31H21C19.9391 31 18.9217 31.4214 18.1716 32.1716C17.4214 32.9217 17 33.9391 17 35V37M39 37V35C38.9993 34.1137 38.7044 33.2528 38.1614 32.5523C37.6184 31.8519 36.8581 31.3516 36 31.13M32 19.13C32.8604 19.3503 33.623 19.8507 34.1676 20.5523C34.7122 21.2539 35.0078 22.1168 35.0078 23.005C35.0078 23.8932 34.7122 24.7561 34.1676 25.4577C33.623 26.1593 32.8604 26.6597 32 26.88M29 23C29 25.2091 27.2091 27 25 27C22.7909 27 21 25.2091 21 23C21 20.7909 22.7909 19 25 19C27.2091 19 29 20.7909 29 23Z",
    stroke: "#008B39",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordOfMouthIsKing);
export default __webpack_public_path__ + "static/media/word-of-mouth-is-king.6cce35e478e31cb31efe5e19cb90ec20.svg";
export { ForwardRef as ReactComponent };